Shopware.Component.extend('sw-cms-el-acris-blog-subtitle', 'sw-cms-el-text', () => import('./component'));
Shopware.Component.extend('sw-cms-el-config-acris-blog-subtitle', 'sw-cms-el-config-text', () => import('./config'));
import './preview';

Shopware.Service('cmsService').registerCmsElement({
    name: 'acris-blog-subtitle',
    label: 'acris-blog.elements.blogSubtitle.label',
    component: 'sw-cms-el-acris-blog-subtitle',
    configComponent: 'sw-cms-el-config-acris-blog-subtitle',
    previewComponent: 'sw-cms-el-preview-acris-blog-subtitle',
    defaultConfig: {
        content: {
            source: 'static',
            value: '<h3>Lorem ipsum dolor sit amet.</h3>',
        },
        verticalAlign: {
            source: 'static',
            value: null,
        }
    }
});